import { render, staticRenderFns } from "./TariffRadioButton.vue?vue&type=template&id=be33da20&scoped=true"
import script from "./TariffRadioButton.vue?vue&type=script&lang=ts"
export * from "./TariffRadioButton.vue?vue&type=script&lang=ts"
import style0 from "./TariffRadioButton.vue?vue&type=style&index=0&id=be33da20&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be33da20",
  null
  
)

export default component.exports